import React, { useState } from 'react';
import { Phone, MessageCircle, CheckCircle2 } from 'lucide-react';
import { BRAND, waLink } from './brand';
import { submitEnquiry } from './api';
import './lead-offer.css';

/**
 * Short call-back form with the 10% land-package offer.
 * Three fields only: name, phone, destination (pre-filled from the page).
 * Leads go through submitEnquiry -> /api/inquiries + CRM v2 capture.
 */
const LeadOffer = ({ destination = '', pageLabel = '' }) => {
  const [f, setF] = useState({ name: '', phone: '', destination });
  const [s, setS] = useState({ busy: false, ok: false, err: '' });
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setS({ busy: true, ok: false, err: '' });
    try {
      await submitEnquiry({
        name: f.name.trim(),
        phone: f.phone.trim(),
        email: '',
        destination: f.destination.trim(),
        message: `Website call-back request (10% land package offer) - page: ${pageLabel || window.location.pathname}`,
        productType: 'tour',
      });
      setS({ busy: false, ok: true, err: '' });
    } catch {
      setS({ busy: false, ok: false, err: `Sorry, that did not go through. Please call ${BRAND.phone}.` });
    }
  };

  return (
    <section className="vk-offer" id="callback">
      <div className="vk-wrap vk-offer__grid">
        <div className="vk-offer__copy">
          <span className="vk-offer__badge">10% OFF</span>
          <h2 className="vk-display vk-offer__title">10% off the land package</h2>
          <p className="vk-offer__sub">For every traveller. Leave your number and our team will call you back with a plan and quote.</p>
          <div className="vk-offer__alt">
            <a className="vk-btn vk-btn--hot" href={BRAND.phoneLink}><Phone size={18} /> Call {BRAND.phone}</a>
            <a className="vk-btn vk-btn--whatsapp" href={waLink(`Hi VK Tours, I would like the 10% land package offer. ${destination ? 'Destination: ' + destination : ''}`)} target="_blank" rel="noopener noreferrer"><MessageCircle size={18} /> WhatsApp</a>
          </div>
        </div>
        <div className="vk-offer__card">
          {s.ok ? (
            <div className="vk-alert vk-alert--ok" role="status"><CheckCircle2 size={18} /> Thank you. Our team will call you back shortly.</div>
          ) : (
            <form className="vk-form" onSubmit={submit}>
              <div className="vk-field"><label htmlFor="lo-name">Your name *</label><input id="lo-name" required value={f.name} onChange={set('name')} autoComplete="name" /></div>
              <div className="vk-field"><label htmlFor="lo-phone">Phone number *</label><input id="lo-phone" required type="tel" inputMode="tel" pattern="[0-9+ ()-]{10,16}" value={f.phone} onChange={set('phone')} autoComplete="tel" /></div>
              <div className="vk-field"><label htmlFor="lo-dest">Where do you want to go?</label><input id="lo-dest" value={f.destination} onChange={set('destination')} /></div>
              {s.err ? <div className="vk-alert vk-alert--err" role="alert">{s.err}</div> : null}
              <button type="submit" className="vk-btn vk-btn--hot" disabled={s.busy}>{s.busy ? 'Sending...' : 'Call me back'}</button>
              <p className="vk-form__note">Offer applies to the land package (not flights or visa).</p>
            </form>
          )}
        </div>
      </div>
    </section>
  );
};

export default LeadOffer;
